import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions.js'
import getters from './getters.js'
import mutations from './mutations.js'

import user from './modules/user'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiKey: undefined,
    view: 'login',
    isLogin: false,
    quick_replies: null,
    isJustLogin: false,
    page: null,
    getWelcome: true
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    user: user
  }
})
